import React, { useState } from 'react'
import PageLayout from '../../../layoutcontainers/PageLayout'
import { Alert, Button, Container, Snackbar, TextField, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../../Utils/Baseurl'

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        email: '',
        emailStatus: 'unchecked',
        emailError: ''
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info',
    });

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailPattern.test(email)
    }

    const handleChange = (e) => {
        const { value } = e.target

        setData(prev => ({
            ...prev,
            email: value,
            emailStatus: value ? (validateEmail(value) ? 'valid' : 'invalid') : 'unchecked',
            emailError: value ? (validateEmail(value) ? '' : 'Please enter a valid email address') : ''
        }))
    }


    const handleSubmit = async () => {
        const { email } = data;
        try {
            const response = await axios.post(`${BASE_URL}api/verify_email/`, {
                email: email
            });
            console.log(response);
            // navigate('/reset-password');
            setSnackbar({
                open: true,
                message: response.data.message,
                severity: 'success',
            });
        } catch (error) {
            console.log(error);
            setSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error',
            });
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };


    return (
        <PageLayout background="white" height='100%' showNavbar disableFooter>
            <Container
                maxWidth="sm"
                sx={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Project Management
                </Typography>

                <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 2 }}>
                    Forgot your password?
                </Typography>

                <TextField
                    placeholder="Enter your email"
                    variant="outlined"
                    value={data.email}
                    onChange={handleChange}
                    fullWidth
                    sx={{ mt: 2, maxWidth: '300px' }}
                    error={data.emailStatus === 'invalid'}
                    helperText={data.emailError}
                />

                <Button
                    variant="contained"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={data.emailStatus !== 'valid'}
                    sx={{
                        mt: 2,
                        maxWidth: '300px',
                        backgroundColor: '#5f6ec2',
                        color: '#fff',
                        textTransform: 'none',
                        padding: '10px 0',
                        '&:hover': {
                            backgroundColor: '#5f6ec2',
                        },
                    }}
                >
                    Get Link
                </Button>

                <Link
                    to="/login"
                    style={{ mt: 5, color: '#666', fontSize: '10px', textDecoration: 'none' }}
                >
                    Return to login
                </Link>
            </Container>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </PageLayout>
    )
}

export default ForgotPassword